<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津港旅物业管理旅游培训有限公司</div>
                  <p class="p1">
                    瑞金花园坐落于天津市河西区紫金山路，与五星级大酒店喜来登毗邻，环境优美，旺中带静，交通网络完善，四通八达。瑞金花园总占地面积8648.24平方米，建有两款独立及半独立复式豪华别墅，适合不同家庭居住。
                  </p>
                  <p class="p2">
                    别墅由名师设计，采用顶级的建材精雕细琢而成，优美典雅，匠心独具,附送高级豪华家私，所有别墅均享有花园环境及停车场,各户设有中央冷暖空调，宽带网接入以及卫星电视接收天线。
                  </p>
                  <div class="p2">
                    瑞金花园主要经营范围：出租高档别墅并进行五星级酒店式物业管理服务，包括垃圾收集、邮递服务、工程维修、报刊订阅等；24小时严密保安和自动监控系统的应用，确保住户的安全。
                  </div>
                  <div class="p2">
                    客房：16栋别墅，50多间客房 服务设施：健身中心及室内游泳池
                    瑞金花园作为别墅式酒店客户主要面向在津办公的小微型企业、高档会所等企业型客户。
                  </div>
                  <div class="img1">
                    <img src="@/assets/images/tjgly1.png" alt="" height="500px" />
                  </div>
                  
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>